(function(){
    if (window.__brfW7) return; window.__brfW7 = true;
    var doc = document;
    /* Price row: on 1.9 the title sat outside the product form, so brf-design-fixes moves the price to just above the form.
       On 7 the title is inside the form, so put the price straight under the title block instead. */
    function priceUnderTitle(){
      var info = doc.querySelector('.product-block-list__item--info'); if (!info) return;
      var meta = info.querySelector('.product-info__block-item--product-meta');
      var vsel = info.querySelector('.product-info__block-item--variant-selector');
      var row = vsel && vsel.querySelector('.product-form__info-list .product-form__info-item');
      var box;
      if (row && row.querySelector('.price-list')) {
        /* the variant picker was redrawn with a fresh price: swap it into the price box */
        [].forEach.call(info.querySelectorAll('.brf-price-first'), function(b){ b.parentNode.removeChild(b); });
        box = doc.createElement('div'); box.className = 'product-form__info-list brf-price-first';
        box.appendChild(row);
        if (meta) meta.parentNode.insertBefore(box, meta.nextSibling); else vsel.parentNode.insertBefore(box, vsel);
      } else {
        box = info.querySelector('.brf-price-first');
        if (box && meta && meta.nextElementSibling !== box) meta.parentNode.insertBefore(box, meta.nextSibling);
      }
    }
    /* 1.9 cards, mini-cart and cart rows use lazysizes markup (class="lazyload" data-src="..{width}x.."); Warehouse 7 has no lazysizes, so load them here. */
    function pickWidth(img){
      var ws = []; try { ws = JSON.parse(img.getAttribute('data-widths') || '[]'); } catch(e){ ws = []; }
      if (!ws.length) ws = [200,300,400,500,600,700,800,900,1000,1200];
      var cw = img.getBoundingClientRect().width || (img.parentNode && img.parentNode.offsetWidth) || 300;
      var need = cw * (window.devicePixelRatio || 1);
      for (var i = 0; i < ws.length; i++) if (ws[i] >= need) return ws[i];
      return ws[ws.length - 1];
    }
    function loadImg(el){
      if (!el.classList.contains('lazyload')) return;
      var src = el.getAttribute('data-src'), ss = el.getAttribute('data-srcset');
      if (ss) el.setAttribute('srcset', ss);
      if (src) el.setAttribute('src', src.indexOf('{width}') > -1 ? src.replace('{width}', pickWidth(el)) : src);
      el.classList.remove('lazyload'); el.classList.add('lazyloaded');
      try { el.dispatchEvent(new CustomEvent('lazyloaded', {bubbles: true})); } catch(e){}
    }
    var io = window.IntersectionObserver ? new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ io.unobserve(e.target); loadImg(e.target); } }); }, {rootMargin: '400px 0px'}) : null;
    function lazyScan(){
      [].forEach.call(doc.querySelectorAll('.lazyload:not([data-brf-lz])'), function(el){
        el.setAttribute('data-brf-lz', '1');
        if (io) io.observe(el); else loadImg(el);
      });
    }
    /* Clearpay line: brf-clearpay wires the first line only; Warehouse 7 redraws it on variant change, so keep the redrawn one in step with price x length */
    function cpUpd(){
      var info = doc.querySelector('.product-block-list__item--info'); if (!info) return;
      var line = info.querySelector('[data-brf-cpay]'); if (!line) return;
      var txt = line.querySelector('[data-brf-cpay-txt]'); var pl = line.closest('.product-form__info-content') || info;
      var p = pl.querySelector('.price-list .price--highlight') || pl.querySelector('.price-list .price'); if (!p || !txt) return;
      var n = parseFloat(p.textContent.replace(/[^0-9.]/g, '')); if (isNaN(n)) return;
      var q = info.querySelector('[name="quantity"]'); var qv = q ? parseInt(q.value, 10) : 1; if (!(qv > 0)) qv = 1;
      var t = Math.round(n * 100) * qv, min = +line.getAttribute('data-min') || 100, max = +line.getAttribute('data-max') || 100000;
      line.hidden = t < min;
      var html = t <= max ? 'or 4 interest-free payments of <b>\u00a3' + (Math.round(t / 4) / 100).toFixed(2) + '</b> with' : 'Pay in 4 on orders up to \u00a3' + (max / 100) + ' with';
      if (txt.innerHTML !== html) txt.innerHTML = html;
    }
    ['input', 'change', 'click'].forEach(function(ev){ doc.addEventListener(ev, function(){ setTimeout(cpUpd, 0); setTimeout(cpUpd, 400); }, true); });
    /* Length/quantity dropdown "10+" (as on Warehouse 1.9): picking it swaps the dropdown for a box you can type any amount into */
    doc.addEventListener('change', function(e){
      var s = e.target; if (!s.matches || !s.matches('select.product-form__quantity')) return;
      var o = s.options[s.selectedIndex]; if (!o || !/\+$/.test(o.textContent.trim())) return;
      var i = doc.createElement('input'); i.type = 'number'; i.name = 'quantity'; i.id = s.id; i.min = '1'; i.value = s.value; i.inputMode = 'numeric';
      i.className = 'form__field form__field--small form__field--text product-form__quantity brf-qty-box';
      var w = s.closest('.select-wrapper') || s; w.parentNode.replaceChild(i, w);
      setTimeout(function(){ i.focus(); i.select(); }, 0);
      i.dispatchEvent(new Event('input', {bubbles: true}));
    });
    /* Quick view: brf-qv-slate hides sold-out choices once; Warehouse 7 redraws the choices after each pick, so hide them again */
    function qvHide(){
      [].forEach.call(doc.querySelectorAll('.modal[id^="modal-quick-view"]'), function(m){
        var j = m.querySelector('script[data-product-json]'); if (!j) return;
        var vs; try { vs = j.__brfVs || (j.__brfVs = (JSON.parse(j.textContent).product || {}).variants || []); } catch (e) { return; }
        if (!vs.some(function(v){ return v.available; })) return;
        function ok(pos, val){ return vs.some(function(v){ return v.available && v['option' + pos] === val; }); }
        [].forEach.call(m.querySelectorAll('input.product-form__single-selector[type=radio][data-option-position]'), function(r){
          if (r.checked) return;
          var box = r.closest('.block-swatch,.color-swatch,.variant-swatch') || r.parentNode;
          if (box.style.display !== 'none' && !ok(r.getAttribute('data-option-position'), r.value)) box.style.display = 'none';
        });
        [].forEach.call(m.querySelectorAll('select.product-form__single-selector[data-option-position]'), function(s){
          var pos = s.getAttribute('data-option-position');
          [].slice.call(s.options).forEach(function(o){ if (!o.selected && !ok(pos, o.value)) o.remove(); });
        });
      });
    }
    /* Length box: never more than the stock left (max is kept up to date by brf-v3), and + greys out at the limit */
    function qClamp(){
      [].forEach.call(doc.querySelectorAll('.brf-qglass'), function(p){
        var i = p.querySelector('input[name="quantity"]'); if (!i) return;
        var max = parseInt(i.getAttribute('max'), 10), v = parseInt(i.value, 10);
        if (max > 0 && v > max) { i.value = max; i.dispatchEvent(new Event('input', {bubbles: true})); }
        var plus = p.querySelector('[data-action="increase-picker-quantity"]'), minus = p.querySelector('[data-action="decrease-picker-quantity"]');
        v = parseInt(i.value, 10) || 1;
        if (plus) plus.disabled = max > 0 && v >= max;
        if (minus) minus.disabled = v <= (parseInt(i.getAttribute('min'), 10) || 1);
      });
    }
    ['click', 'input', 'change'].forEach(function(ev){ doc.addEventListener(ev, function(){ setTimeout(qClamp, 0); }, true); });
    setInterval(qClamp, 500);
    function run(){ priceUnderTitle(); lazyScan(); cpUpd(); qvHide(); [].forEach.call(doc.querySelectorAll('.brf-price-first'), function(b){ if (!b.children.length) b.parentNode.removeChild(b); }); }
    run();
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', run);
    if (window.MutationObserver) {
      var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(run, 30); }).observe(doc.documentElement, {childList: true, subtree: true});
    }
  })();
